import React, { useState, useEffect, useContext } from 'react';
import DataContext from '../components/DataContext/DataContext';
import { useNavigate } from 'react-router-dom';
import TextTranslatable from '../components/Internationalization/TextTranslatable';
import useRoutes from '../routes/useRoutes';
import Checkbox from '@ingka/checkbox';
import RadioButton from '@ingka/radio-button';
import styled from 'styled-components';
import Button from '@ingka/button';

const Container = styled.div`
  // margin: 20px 20px;
  // padding: 15px 15px;
  margin: 20px 20px 8px 20px;
  padding: 15px 15px 13px 15px;
  border: 5px solid #dfdfdfa6;
  background: #dfdfdf3d;
  border-radius: 15px;
  box-shadow: 2px 2px 7px #808080c4;
`;
const StyledCheckbox = styled(Checkbox)`
  padding: 5px 5px;
`;
const StyledRadio = styled(RadioButton)`
  padding: 5px 5px;
`;
const CheckboxConatiner = styled.div`
  margin-top: 1rem;
  margin-bottom: 1.4rem;
  display: grid;
  grid-template-columns: ${props => `repeat(${props.length},1fr)`};
`;


const SettingsView = () => {
  const { config, language, allSalesPoint, allStores, setQuery, setInteractionCount} = useContext(DataContext);
  const [selectedSalesArea, setSelectedSalesArea] = useState([]);
  const [allSalesArea, setAllSalesArea] = useState([]);
  const [selectedStore, setSelectedStore] = useState( [] );
  const [allStore, setAllStore] = useState([]);
  const history = useNavigate();
  const route = useRoutes();


const salesAreas = []
const stores =[]

config && config.salesPointCode
.filter(itm =>  itm.isActive)
.map(item=>{
  let obj = {};
  obj.code = item.code;
  obj.name = item.info[language].name;
  salesAreas.push(obj)
});

config && config.storeCode.map(item=>{
  let obj = {};
  obj.code = item.code;
  obj.name = item.info[language].name;
  stores.push(obj)
});

//adding alphabetic sorting to sales and store lists to display in UI
  let store = stores.sort((a,b)=>a.name.localeCompare(b.name));
  let salesArea = salesAreas.sort((a,b)=>a.name.localeCompare(b.name));


  useEffect(() => {
    const allSalesAreaCodes = salesArea.map(item =>item.code);
    setAllSalesArea(allSalesAreaCodes);
    const allStoreCodes = store.map(item =>item.code);
    setAllStore(allStoreCodes);

    // setting and fecthing selected store code to local storage;
    if(localStorage.getItem('store') === null){
      localStorage.setItem('store', JSON.stringify(allStores)) 
    }
    setSelectedStore(JSON.parse(localStorage.getItem('store'))) 

    // setting and fecthing selected store area to local storage;
    if(localStorage.getItem('salesArea') === null){
      localStorage.setItem('salesArea', JSON.stringify(allSalesPoint));
    };
    
    setSelectedSalesArea(JSON.parse(localStorage.getItem('salesArea')));

  }, []);

  const handleInteraction=()=>{
    const interactionData = JSON.parse(localStorage.getItem('interactionData'));
    setInteractionCount(prevCount => {
        const newCount = prevCount + 1;
        const updatedData = {
          ...interactionData,
          interactionCount: newCount,
          //date: formatDateTime(new Date())
        };
        localStorage.setItem('interactionData', JSON.stringify(updatedData));
        return newCount;
      });
  }
  const handleConfirm = () => {
    let copySelectedStore = [...selectedStore];
    let copySelectedSalesArea = [...selectedSalesArea];
    localStorage.setItem('store', JSON.stringify(copySelectedStore));
    localStorage.setItem('salesArea', JSON.stringify(copySelectedSalesArea));
    setQuery("");
    history({ pathname: route.menuRoute() });
  };

  const handleSalesAreaChange = (code, e) => {
    const tmpSelectedSalesArea = [...selectedSalesArea];
    if (code === 'all') {
      e.target.checked === true
        ? setSelectedSalesArea(allSalesArea)
        : setSelectedSalesArea([]);
    } else {
      if (e.target.checked === true) {
        tmpSelectedSalesArea.push(code);
      } else {
        let index = tmpSelectedSalesArea.indexOf(code);
        if (index > -1) {
          tmpSelectedSalesArea.splice(index, 1);
        }
      }
      setSelectedSalesArea(tmpSelectedSalesArea);
    }
   // handleInteraction();
  };

  const handleStoreChange = (code, e) => {
    const tmpSelectedStore = [...selectedStore];
    if (code === 'all') {
      e.target.checked === true
        ? setSelectedStore(allStore)
        : setSelectedStore([]);
    } else {
      if (e.target.checked === true) {
        tmpSelectedStore.push(code);
      } else {
        let index = tmpSelectedStore.indexOf(code);
        if (index > -1) {
          tmpSelectedStore.splice(index, 1);
        }
      }
      setSelectedStore(tmpSelectedStore);
    }
  };
const handleStoreRadio=(store)=>{
  setSelectedStore(store);
  //handleInteraction();
}
  return (
    <>
      <Container>
        <div>
          <label>
          <TextTranslatable textId="choose_store" />
          </label>
          <CheckboxConatiner length={store.length < 8 ? 2 : 3}>
            {store.length > 0 && (
              <StyledRadio
                label={<TextTranslatable textId="all" />}
                id={`store-all`}
                name='store'
                onChange={() => handleStoreRadio(allStore)}
                value='all'
                checked={selectedStore.length === allStore.length}
              />
            )}
            {store.map(item => (
              <StyledRadio
                name='store'
                value={item.code}
                key={item.code}
                label={item.name}
                id={`store-${item.code}`}
                onChange={() => handleStoreRadio([item.code])}
                checked={
                  selectedStore.length === 1 && selectedStore[0] === item.code
                }
              />
            ))}
          </CheckboxConatiner>
        </div>
        <div>
          <label>
          <TextTranslatable textId="choose_sales_points" />
            </label>
          <CheckboxConatiner length={salesArea.length < 8 ? 2 : 3}>
            {salesArea.length > 2 && (
              <StyledCheckbox
              label={<TextTranslatable textId="all" />}
                // label="All"
                id={`salespoint-all`}
                onChange={e => {
                  handleSalesAreaChange('all', e);
                }}
                checked={selectedSalesArea.length === allSalesArea.length}
              />
            )}
            {salesArea.map(item => (
              <StyledCheckbox
                key={item.code}
                id={`salespoint-${item.code}`}
                label={item.name}
                onChange={e => {
                  handleSalesAreaChange(item.code, e);
                }}
                checked={selectedSalesArea.indexOf(item.code) > -1}
              />
            ))}
          </CheckboxConatiner>
          <br />
        </div>
        {(salesArea.length > 0 || store.length > 0) && (
          <div>
            <Button
              type="emphasised"
              small={true}
              text={<TextTranslatable textId="confirm" />}
              onClick={e => handleConfirm()}
            />
            <br />
            <br />
          </div>
        )}
      </Container>
    </>
  );
};

export default SettingsView;
